/*
 * @Author: Kuiper
 * @Date: 2021-06-25 10:36:11
 */
import { isDevelopment } from '/@/api/config'
import { defHttp } from '/@/utils/http/axios'
import md5 from 'crypto-js/md5'
import { ContentTypeEnum } from '/@/enums/httpEnum'
import { LoginParams, LoginResultModel, AccessInfo, ReCoocaaAccountInfo } from './userModel'

enum Api {
  Login = '/login',
  GetUserInfo = '/getUserInfo',
  TestApi = 'https://beta.passport.coocaa.com/api/screen/agora-token-by-uid',
  TestMockApi = '/mock/zy/aaa',
  testdevicetList = '/mock/yss/devicetList',
  testCompanyInfo = '/mock/yss/companyInfo',
  testMemberList = '/mock/yss/memberList',
}

import { AxiosResponse } from 'axios'
const isDev = isDevelopment()
const baseUrl = isDev ? 'https://beta.passport.coocaa.com' : 'https://passport.coocaa.com' //
const CLIENT_ID_COOCAA = isDev
  ? '20030b3587ab4f9a9739185237319a46'
  : '25c7c236ccf84b7e8ebac9aa71531f07' //client_id：25c7c236ccf84b7e8ebac9aa71531f07 client_secret：pbSWEUWHhOXsszxa
const CLIENT_SECRET_COOCAA = isDev ? 'KSiVM12wRNu1WNN5' : 'pbSWEUWHhOXsszxa' //
const SHARE_DISK_CODE_KEY = 'share_disk_request_coocaa' + randomString(10) //需要保证每次得acode值不一样，避免发生覆盖问题，出现图片验证码输入正确提示错误得问题

function processURL(paramsMap: any = {}) {
  Object.assign(paramsMap, {
    time: Math.round(new Date().getTime() / 1000),
    client_id: CLIENT_ID_COOCAA,
  })
  let url = ''
  let sign = ''
  Object.keys(paramsMap)
    .sort()
    .forEach(function (key) {
      url += key + '=' + encodeURIComponent(paramsMap[key]) + '&'
      sign += key + '=' + paramsMap[key] + '&'
    })
  sign = sign.slice(0, sign.length - 1)
  sign += CLIENT_SECRET_COOCAA
  sign = md5(sign).toString()
  url += 'sign=' + sign
  return {
    url,
    sign,
  }
}
function randomString(len) {
  len = len || 32
  const $chars =
    'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678' /****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
  const maxPos = $chars.length
  let pwd = ''
  for (let i = 0; i < len; i++) {
    pwd += $chars.charAt(Math.floor(Math.random() * maxPos))
  }
  return pwd
}
export function getCaptchaApi(iconWidth?: number, iconHeight?: number) {
  const data = {
    width: iconWidth,
    height: iconHeight,
    codeKey: SHARE_DISK_CODE_KEY,
  }
  const params = {
    client_id: CLIENT_ID_COOCAA,
    time: Math.round(new Date().getTime() / 1000),
    sign: '',
  }
  const signParam = processURL()
  params.sign = signParam.sign
  return defHttp.post({
    url: baseUrl + `/skyapi/common/getValidCode`,
    headers: {
      'content-type': ContentTypeEnum.FORM_URLENCODED,
    },
    params,
    data,
    responseType: 'blob',
  })
}

export function getCaptcha(mobile: string, iconCapcha: string) {
  const data = {
    codeKey: SHARE_DISK_CODE_KEY,
    mobile_email: mobile,
    capcha: iconCapcha,
  }
  const params = {
    client_id: CLIENT_ID_COOCAA,
    time: Math.round(new Date().getTime() / 1000),
    sign: '',
  }
  const signParam = processURL({})
  params.sign = signParam.sign
  return defHttp.post<AxiosResponse>({
    url: baseUrl + `/skyapi/common/captcha-new`,
    headers: {
      'content-type': ContentTypeEnum.FORM_URLENCODED,
    },
    params,
    data,
  })
}
export function loginByCaptcha(mobile: string, captcha: string) {
  const data = {
    mobile,
    captcha,
    mac: '11:11:FE:11:11',
    model: 'web',
    core: 'shareDisk',
  }
  const params = {
    client_id: CLIENT_ID_COOCAA,
    time: Math.round(new Date().getTime() / 1000),
    sign: '',
  }
  const signParam = processURL({})
  params.sign = signParam.sign
  return defHttp.post<AccessInfo>({
    url: baseUrl + `/skyapi/user/login/mobile`,
    headers: {
      'content-type': ContentTypeEnum.FORM_URLENCODED,
    },
    params,
    data,
  })
}

export function requireAccInfo(ak: string) {
  const params = {
    client_id: CLIENT_ID_COOCAA,
    time: Math.round(new Date().getTime() / 1000),
    sign: '',
    access_token: ak,
  }
  const signParam = processURL({})
  params.sign = signParam.sign
  return defHttp.get<ReCoocaaAccountInfo>({
    url: baseUrl + `/api/user/info`,
    headers: {
      'content-type': ContentTypeEnum.FORM_URLENCODED,
    },
    params,
  })
}

export function testApi() {
  console.log('api testApi in')
  const params = {
    channelName: '12345678',
    role: 1,
    uid: 0,
    expireTimeInSeconds: 36000,
  }
  return defHttp.get<any>({ url: Api.TestApi, params })
}

export function testMockApi() {
  console.log('api testMockApi in')
  return defHttp.get<any>({ url: Api.TestMockApi })
}

export function MockdeviceList() {
  console.log('api testMockApi in')
  return defHttp.get<any>({ url: Api.testdevicetList })
}
export function MockcompanyInfo() {
  console.log('api testMockApi in')
  return defHttp.get<any>({ url: Api.testCompanyInfo })
}

export function MockmemberList() {
  console.log('api testMockApi in')
  return defHttp.get<any>({ url: Api.testMemberList })
}
/**
 * @description: user login api
 */
export function loginApi(params: LoginParams) {
  return defHttp.post<LoginResultModel>({
    url: Api.Login,
    params,
  })
}
